import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.tsx";
import TermsOfService from "./pages/TermsOfService.tsx";
import Blog from "./pages/Blog.tsx";
import BlogPost from "./pages/BlogPost.tsx";
import ScrollToTop from "./components/ScrollToTop.tsx";

import "./index.css";

// Initialize Sentry
Sentry.init({
  dsn: "https://2daef6539121b70f787e3c1feec4a842@o530949.ingest.us.sentry.io/4510133774843904",
  environment: import.meta.env.MODE,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={({ error, resetError }) => (
      <div className="min-h-screen flex items-center justify-center bg-slate-900 text-white">
        <div className="text-center p-8">
          <h1 className="text-2xl font-bold mb-4">Something went wrong</h1>
          <p className="text-slate-400 mb-6">We've been notified and are working to fix this issue.</p>
          {import.meta.env.DEV && error ? (
            <details className="text-left bg-slate-800 p-4 rounded-lg mb-4 max-w-md">
              <summary className="cursor-pointer text-sm text-slate-300">Error details</summary>
              <pre className="text-xs text-red-400 mt-2 overflow-auto">
                {error instanceof Error ? error.message : String(error)}
              </pre>
            </details>
          ) : null}
          <button 
            onClick={resetError}
            className="bg-teal-500 hover:bg-teal-600 text-white px-6 py-2 rounded-full transition-colors"
          >
            Try again
          </button>
        </div>
      </div>
    )}>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
        </Routes>
      </Router>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
